module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " medicalRecordArea"
  }, [_c('div', {
    staticClass: "crumbs"
  }, [_c('span', [_vm._v("首页")]), _vm._v(">\n      "), _c('span', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MedicalRecord'
      }
    }
  }, [_vm._v("典型病例库")])], 1), _vm._v(" >\n      "), (_vm.bread === 'update') ? _c('span', [_vm._v("修改病例")]) : _c('span', [_vm._v("新增病例")])]), _vm._v(" "), _c('div', {
    staticClass: "layout_left_m"
  }, [_c('div', {
    ref: "leftH",
    staticClass: "margin10_box medicalRecord_left"
  }, [(_vm.fromShow) ? _c('collapse-medical-record', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "tabs": _vm.tabs,
      "defaultChecked": _vm.defaultTreeChecked,
      "showCheckBox": true,
      "personList": _vm.personList,
      "treeData": _vm.treeData,
      "tabActive": _vm.tabActive,
      "defaultPersonList": _vm.defaultPersonListChecked,
      "catalogSubType": _vm.catalogSubType,
      "defaultPersonListChecked": _vm.defaultPersonListChecked,
      "titleList": _vm.titleList,
      "filterText": _vm.filterText
    },
    on: {
      "tabChange": _vm.tabChange,
      "changeColl": _vm.changeColl,
      "delPerson": _vm.delPerson,
      "addPersonList": _vm.addPersonList,
      "searchClick": _vm.searchClick,
      "checkTree": _vm.checkTree,
      "personChecked": _vm.personChecked,
      "treeNodeClick": _vm.treeNodeClick
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.popShow) ? _c('div', {
    staticClass: "layout_right_m "
  }, [_c('div', {
    staticClass: "layout_right_inner_m "
  }, [_c('div', {
    staticClass: "for_width"
  }, [_c('div', {
    ref: "rightH",
    staticClass: "margin10_box",
    staticStyle: {
      "width": "96%"
    }
  }, [(_vm.fromShow) ? _c('div', {
    staticClass: "w96",
    attrs: {
      "width": _vm.width
    }
  }, [_c('i', {
    staticClass: "arrow_first"
  }, [_vm._v(">")]), _vm._v(" "), _c('i', {
    staticClass: "arrow_second"
  }, [_vm._v(">")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "background": "red",
      "top": "34px"
    },
    attrs: {
      "width": _vm.width
    }
  }, [(_vm.rightTabActive === '1') ? _c('el-button', {
    staticClass: "choose_btn medical_btn",
    on: {
      "click": _vm._openScope
    }
  }, [_vm._v("从本院影像选择\n                ")]) : _vm._e()], 1), _vm._v(" "), (_vm.fromShow) ? _c('tabs', {
    attrs: {
      "activeName": _vm.activeName
    },
    on: {
      "tabChange": _vm.rightTabChange
    }
  }, _vm._l((_vm.rightTabs), function(tab) {
    return _c('el-tab-pane', {
      key: tab.name,
      attrs: {
        "label": tab.label,
        "name": tab.name
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rightTabActive === '0'),
        expression: "rightTabActive === '0'"
      }],
      staticClass: "tabConHeight"
    }, [(_vm.fromShow) ? _c('medical-news', {
      ref: "medicalNews",
      refInFor: true,
      attrs: {
        "info": _vm.detail
      },
      on: {
        "detailUpdate": _vm.detailUpdate
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "step_next",
      on: {
        "click": function($event) {
          return _vm.stepMove(1)
        }
      }
    }, [_vm._v("下一步")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rightTabActive === '1'),
        expression: "rightTabActive === '1'"
      }],
      staticClass: "tabConHeight",
      attrs: {
        "width": _vm.width
      }
    }, [_c('p-table', {
      attrs: {
        "head": _vm.personTableHead,
        "height": _vm.tableHeiht,
        "data": _vm.studyList,
        "operation": _vm.personTableOperation,
        "autoheight": _vm.autoheight
      },
      on: {
        "_operation": _vm._operation_
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "step_prev",
      on: {
        "click": function($event) {
          return _vm.stepMove(-1)
        }
      }
    }, [_vm._v("上一步")]), _vm._v(" "), _c('div', {
      staticClass: "step_next",
      on: {
        "click": function($event) {
          return _vm.stepMove(1)
        }
      }
    }, [_vm._v("下一步")])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.rightTabActive === '2'),
        expression: "rightTabActive === '2'"
      }],
      staticClass: "tabConHeight"
    }, [_c('upload', {
      attrs: {
        "updateFileList": _vm.updateFileList,
        "updatePicList": _vm.updatePicList
      },
      on: {
        "fileChange": _vm.fileChange,
        "fileRemove": _vm.fileRemove,
        "fileIsLoading": _vm.fileIsLoading
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "step_prev",
      on: {
        "click": function($event) {
          return _vm.stepMove(-1)
        }
      }
    }, [_vm._v("上一步")])], 1)])
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.popShow && _vm.fromShow) ? _c('buttons', {
    on: {
      "clickbtn": _vm.clickbtn
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.pop) ? _c('pops', {
    class: 'mrDialog',
    attrs: {
      "show": _vm.pop,
      "width": '1200px',
      "title": '从本院影像中选择'
    },
    on: {
      "closePop": _vm.closePop
    }
  }, [_c('pImage', {
    attrs: {
      "studyList": _vm.studyList
    },
    on: {
      "_popshow": _vm._popshow,
      "_popClose": _vm._popshow
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.fromShow) ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "49%",
      "left": "49%"
    }
  }, [_vm._v("加载中......")]) : _vm._e(), _vm._v(" "), _c('aycanImages', {
    ref: "aycanImages",
    attrs: {
      "hospitalId": _vm.params_image.hospitalId,
      "studyPk": _vm.params_image.studyPk,
      "studyUid": _vm.params_image.studyUid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-41ac11f6","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/medicalRecord/newMedicalRecord.vue
// module id = 560
// module chunks = 1 2 3 4 5 6 7 8